// eslint-disable-next-line import/no-extraneous-dependencies
import { Module } from 'vuex';
import { UserInfoByLogin } from '@/api/user';

interface UserModuleType {
    userInfo?: UserInfoByLogin;
    hasQueriedUserInfo: boolean; // 是否已经查询过 userInfo
}

const defaultState: UserModuleType = {
    userInfo: undefined,
    hasQueriedUserInfo: false,
};

export const userModule: Module<UserModuleType, any> = {
    namespaced: true,
    state: defaultState,
    mutations: {
        setUserInfo(state, userInfo?: UserInfoByLogin) {
            state.userInfo = {
                ...(state.userInfo || {}),
                ...(userInfo || {}),
            };
        },
        setHasQueriedUserInfo(state, hasQueriedUserInfo: boolean) {
            state.hasQueriedUserInfo = hasQueriedUserInfo;
        },
    },
    actions: {},
};
